import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import DisplaySettings from "components/dashboard/DisplaySettings";
import SettingsDialogShell from "components/dashboard/layout/SettingsDialogShell";

/**
 * The settings cog for someone who is not signed in (sign-in screens, CareMap). Opens
 * the account menu's Settings dialog (same frame, same rows) with the device's settings only:
 * Appearance and Language. Both are kept on this device, so they carry over after sign-in.
 */
const PublicSettingsButton = ({ sx }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={t("accountMenu.settings")}>
        <IconButton aria-label={t("accountMenu.settings")} onClick={() => setOpen(true)} sx={sx}>
          <SettingsRounded />
        </IconButton>
      </Tooltip>
      <SettingsDialogShell open={open} onClose={() => setOpen(false)} maxWidth="sm">
        <DisplaySettings />
      </SettingsDialogShell>
    </>
  );
};

export default PublicSettingsButton;
